import { render, staticRenderFns } from "./login.vue?vue&type=template&id=4e38e02a&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=4e38e02a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e38e02a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo108: require('/app/components/Logo108.vue').default,NuxtImage: require('/app/components/NuxtImage.vue').default})
